import { giphyDarkCharcoal } from '@giphy/colors'
import UsernameInput from 'shared/components/inputs/username'
import CreationToolUploadField from '../../../types/upload-field'
import Instructions from '../../form-fields/upload/field-instructions'
import CollapsibleField from './field-collapsible'

type Props = {
    className?: string
    field: CreationToolUploadField
    username?: string
    showInstructions?: boolean
    onChange: (username: string) => void
}

export const CreationUsernameField = ({
    className,
    field,
    username = '',
    showInstructions = false,
    onChange,
}: Props) => {
    const placeholder = CreationToolUploadField.description(field)

    return (
        <CollapsibleField className={className} field={field}>
            <UsernameInput
                buttonOptions={{
                    color: giphyDarkCharcoal,
                }}
                placeholder={placeholder}
                showRecents
                size="medium"
                username={username}
                onChange={onChange}
            />
            {showInstructions && <Instructions field={field} />}
        </CollapsibleField>
    )
}

export default CreationUsernameField
